let isGenerated = false;
const elementMap = new Map();

//iterate over group array
//generate key for each element in the group
//then push it to the map
function processElementGroupArray(
    elementGroupName,
    elementGroupArray
) {
    elementGroupArray.forEach(element => {
        const key = `${elementGroupName}/${element.id}`;
        const value = element;
        elementMap.set(key, value);
    });
}

function getAllTypes() {
    const { elementTypes } = require('../elements.json');
    const typeSet = new Set();
    Object.keys(elementTypes).forEach(key => {
        const types = elementTypes[key];
        if (!Array.isArray(types)) {
            return;
        }
        types.forEach(type => typeSet.add(type));
    })
    return Array.from(typeSet);
}

//imports all groups and sends each one to processing in order to generate map
function generateMap() {
    const elementArrays = getAllTypes();
    elementArrays.forEach(elementGroupName => {
        const importedElementGroupArray = require(`./${elementGroupName}`).default;
        processElementGroupArray(elementGroupName, importedElementGroupArray);
    });
}
//lazy evaluation implementation of elementMap generation
//returns map
//key: {element.type}/{element.id}
//element type is banner, cart, header etc.
//id is defined in element
//value: object representing the element
function getElementMap() {
    if (isGenerated) {
        return elementMap;
    }

    generateMap();
    isGenerated = true;
    return elementMap;
}

export default getElementMap;